import type { ReactNode } from 'react';

interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  description?: string;
  align?: 'left' | 'center';
  right?: ReactNode;
}

export default function SectionHeading({
  eyebrow,
  title,
  description,
  align = 'left',
  right,
}: SectionHeadingProps) {
  const isCenter = align === 'center';

  return (
    <div
      className={
        isCenter
          ? 'flex flex-col items-center text-center gap-5'
          : 'flex flex-col gap-5 md:flex-row md:items-end md:justify-between'
      }
    >
      <div className={isCenter ? 'max-w-2xl mx-auto' : 'max-w-2xl'}>
        <span className="inline-flex items-center gap-2 text-xs md:text-sm font-medium tracking-[0.2em] text-primary-700">
          <span className="w-6 h-px bg-primary-500" />
          {eyebrow}
        </span>
        <h2 className="mt-3 text-2xl md:text-4xl font-bold leading-snug text-foreground-950">
          {title}
        </h2>
        {description ? (
          <p className="mt-3 text-sm md:text-base leading-relaxed text-foreground-600">
            {description}
          </p>
        ) : null}
      </div>
      {right ? <div className="shrink-0">{right}</div> : null}
    </div>
  );
}